export const DROPDOWN_STYLES = {
  control: provided => ({
    ...provided,
    minHeight: '3rem',
  }),
}
